import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GoLogoComponent } from './go-logo.component';

@NgModule({
	imports: [
		CommonModule
	],
	declarations: [
		GoLogoComponent
	],
	exports: [
		GoLogoComponent
	]
})
export class GoLogoModule {}
